/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
// @ts-ignore
import withStyles from 'isomorphic-style-loader/lib/withStyles';
// @ts-ignore
import s from './Aboutus.css';
import {Map, Marker} from 'react-amap';
// @ts-ignore
import banner from './BANNER .png'
// @ts-ignore
import icon from './1.png'
// @ts-ignore
import headBg from './aboutUsHead.png'
// @ts-ignore
import advisory from './advisory.png'
// @ts-ignore
import idea from './idea.png'
// @ts-ignore
import diagnosis from './diagnosis.png'
// @ts-ignore
import mind from './mind.png'
// @ts-ignore
import brand from './brand.png'


let mapCenter = {
  longitude: 116.513954,
  latitude: 39.922458
}
// @ts-ignore
const html = `<div><h4>北京数榜信息科技有限公司</h4><p>电话</p><p>邮箱：dbrank@dbrank.net</p><p>地址:北京市朝阳区青年路113号无界空间</p></div>`;

const styleC = {
  backgroundImage: `url('${icon}')`,
  backgroundSize: 'contain',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center',
  width: '24px',
  height: '36px',
  color: '#000',
  textAlign: 'center',
  lineHeight: '40px'
}

class Aboutus extends React.Component {

  constructor() {
    // @ts-ignore
    super()
    this.state = {
      value: '1',
      size: {
        width: 200,
        height: 100
      },
      offset: [10, -30]
    }

  }
  render() {
    return (
      <div className={s.root}>

        <div className={s.logo}>
          <img src={headBg}/>
        </div>
        <div className={s.cont}>
          <div className={s.itemTxt}>
            <h3 className={s.tit}>关于DBRank</h3>
            <span className={s.smallTit}>About Us</span>
            <p className={s.infoTxt}>
              我们是一家传播科技（Communication Technology）公司，运用大数据+机器学习技术，打造传播领域的SaaS服务平台，
            </p>
            <p className={s.infoTxt}>
              为企业公关、广告、市场、营销和运营提供基于社交媒体大数据的传播决策服务，识别战场状况，提高心智占有率，计算品牌在数据时代的数字资产价值。
            </p>
            <p className={s.bold}>
              数字品牌榜，社交媒体时代的用户口碑评价排行榜。
            </p>
          </div>
          <div className={s.itemTxt}>
            <h3 className={s.tit}>愿景</h3>
            <span className={s.smallTit}>Vision</span>
            <p className={s.infoTxt}>
              心智数据解码商业世界
            </p>
            <span className={s.enTxt}>Encode Mind, Decode Business.</span>
          </div>
          <div className={s.itemTxt}>
            <h3 className={s.tit}>使命</h3>
            <span className={s.smallTit}>Mission</span>
            <p className={s.infoTxt}>
              一切为了可量化的数字品牌价值
            </p>
            <span className={s.enTxt}>All about measurable Digital Brand Value.</span>
          </div>
        </div>
        <div className={s.banner}>
          <img src={banner}/>
        </div>
        <div className={s.itemTxt}>
          <h3 className={s.tit}>增值服务</h3>
          <span className={s.smallTit}>Other Services</span>
          <ul className={s.serCon}>
            <li>
              <i><img  src={diagnosis}/></i>
              <b>+诊断</b>
              <p>从口碑舆情的结构化数据中，洞察和分析品牌传播规律，发现问题，发现机会。</p>
            </li>
            <li>
              <i><img src={advisory}/></i>
              <b>+咨询</b>
              <p>从品牌传播定位出发，制定新媒体传播战略、健全新媒体传播体系，并进行战役复盘。</p>
            </li>
            <li>
              <i><img src={idea}/></i>
              <b>+创意</b>
              <p>以专业团队策划传播引爆方案，提供内容创作、创意设计、影响者营销等全案服务。</p>
            </li>
          </ul>
        </div>
        <div className={s.media}>
          <h3 className={s.tit}>数榜新媒体</h3>
          <span className={s.smallTit}>In-House Media</span>
          <ul className={s.mediaCon}>
            <li>
              <i><img  src={mind}/></i>
              <b>数字智库</b>
              <em>Mentor | Media | Megadata</em>
              <p>一个专注于传播科技研究的兴趣小组。邀请和集聚国内外一流研究学者和领先的新媒体实践者，促进认知升级，关注数字趋势，共同探讨科学营销的知行之合一，并广泛触及品牌传播、社交媒体、消费洞察、商业创新、人工智能等话题。</p>
            </li>
            <li>
              <i><img src={brand}/></i>
              <b>数字品牌榜</b>
              <em>Matrix | Mindshare | Map</em>
              <p>社交媒体时代的用户口碑评价排行榜，让传播效果可量化、可视化，侦测品牌的用户心智占有率，让数据说话，辅助科学决策。</p>
            </li>
          </ul>
        </div>

        <div className={s.content}>

          <div className={s.usHead}>

            <h3 className={s.tit}>联系我们</h3>
            <span className={s.smallTit}>Contact us</span>
          </div>
          <div className={s.usCon}>

            <ul className={s.ulTxt}>
              <li>
                媒体联系：pr@dbrank.net
              </li>
              <li>
                加入我们：hr@dbrank.net
              </li>
              
               
              <li> {`地   址：北京市朝阳区朝阳北路104号楼1205`} </li>
            </ul>
            <div
              style={{
              width: '500px',
              height: '270px'
            }}
              className={s.map}>
              <Map center={mapCenter} zoom={15} amapkey={'36d462a045efd7e16761c920bf15c0d7'}>
                <Marker position={mapCenter}>
                  <div style={styleC}></div>
                </Marker >
                {/* <InfoWindow
                position={mapCenter}
                content={html}
                size={this.state.size}
                visible={true}
                offset={this.state.offset}
              /> */}
              </Map>
            </div>
          </div>

        </div>

      </div >
    )

  }
}

export default withStyles(s)(Aboutus);



// WEBPACK FOOTER //
// src/routes/aboutus/Aboutus.js